<template>
  <div
    itemscope
    itemtype="https://schema.org/FAQPage"
  >
    <h2 v-show="listHeader">
      {{ listHeader }}
    </h2>
    <p v-show="listDescription">
      {{ listDescription }}
    </p>
    <faq-item
      v-for="(item,index) in listItems"
      :key="index"
      :item-head="item.question"
      :item-text="item.answer"
      :item-collapsible="item.itemCollapsible"
    />
  </div>
</template>
<script>
import FaqItem from 'components/FaqItem.vue';

export default {
  name: 'FaqList',
  components: {
    FaqItem
  },
  props: {
    listElements: {
      type: [Array, Boolean],
      default: false
    },
    listHeader: {
      type: String,
      default: 'Listenüberschrift'
    },
    listDescription: {
      type: String,
      default: 'Hier könnte ihre Werbung stehen'
    },
  },
  data() {
    return {
      showFaq: false,
    };
  },
  computed: {
    listItems() {
      if (this.listElements.length) {
        return this.listElements;
      }
      return [];
    },
  },
};
</script>
